import { CellContext } from '@tanstack/react-table'
import * as React from 'react'
import { UserPersonalSkillsTableRow } from '../data'

export const DescriptionCell = (
  data: CellContext<UserPersonalSkillsTableRow, string | null>
) => {
  const description = data.getValue()
  if (!description) return <span className="text-gray-400">-</span>

  const truncated =
    description.length > 50 ? description.substring(0, 50) + '...' : description

  return (
    <span className="text-gray-600 text-sm" title={description}>
      {truncated}
    </span>
  )
}
